import PropTypes from 'prop-types'
import { useCallback, useEffect, useRef } from 'react'

import SectionsListItem from './SectionsListItem'

const SectionsList = ({
  lineHeight = 24,
  readMoreLimit,
  sections,
  isExpanded
}) => {
  const firstHiddenElRef = useRef(null)

  const calculateHeight = useCallback(() => {
    if (sections.length > readMoreLimit) {
      return isExpanded
        ? `${lineHeight * sections.length}px`
        : `${lineHeight * readMoreLimit}px`
    }
    return 'auto'
  }, [sections, readMoreLimit, isExpanded, lineHeight])

  useEffect(() => {
    if (isExpanded === true) {
      firstHiddenElRef.current?.focus()
    }
  }, [isExpanded, firstHiddenElRef])

  return(
    <ol
      className='table-of-contents copy--medium mb-0'
      style={{ height: calculateHeight() }}
    >
      {sections.map((section, index) => (
        <SectionsListItem
          focusable={readMoreLimit === index ? true : false}
          hidden={(readMoreLimit <= index && !isExpanded) ? true : false}
          key={index}
          ref={readMoreLimit === index ? firstHiddenElRef : null}
          section={section}
        />
      ))}
    </ol>
  )
}

export default SectionsList

SectionsList.propTypes = {
  isExpanded: PropTypes.bool,
  lineHeight: PropTypes.number,
  readMoreLimit: PropTypes.number,
  sections: PropTypes.array,
}